import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "status", "testButton"]
  static values = { 
    clientId: String,
    platform: String,
    saveUrl: String
  }

  connect() {
    console.log(`${this.platformValue} webhook config controller connected`)
  }

  async save() {
    const url = this.urlTarget.value.trim()
    
    if (!url) {
      this.showStatus(`Please enter a ${this.platformValue} webhook URL`, "error")
      return
    }

    // Validate URL format
    if (!this.isValidWebhookUrl(url)) {
      this.showStatus(`Please enter a valid ${this.platformValue} webhook URL`, "error")
      return
    }

    try {
      const response = await fetch(this.saveUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          client: {
            [`${this.platformValue}_webhook_url`]: url
          }
        })
      })

      if (response.ok) {
        this.showStatus(`${this.platformValue} webhook URL saved successfully`, "success")
        // Update the UI to show that the webhook is configured
        this.updateWebhookStatus(true)
      } else {
        const error = await response.json()
        this.showStatus(error.error || `Failed to save ${this.platformValue} webhook URL`, "error")
      }
    } catch (error) {
      console.error(`Error saving ${this.platformValue} webhook URL:`, error)
      this.showStatus(`Failed to save ${this.platformValue} webhook URL`, "error")
    }
  }

  async test() {
    const url = this.urlTarget.value.trim()
    
    if (!url) {
      this.showStatus(`Please enter a ${this.platformValue} webhook URL first`, "error")
      return
    }

    this.testButtonTarget.disabled = true
    this.testButtonTarget.textContent = "Testing..."

    try {
      // For now, just show a success message since we don't have test endpoints for HeyReach/Instantly
      // In the future, we could add actual test endpoints
      this.showStatus(`${this.platformValue} webhook URL is valid`, "success")
    } catch (error) {
      console.error(`Error testing ${this.platformValue} webhook:`, error)
      this.showStatus(`Failed to test ${this.platformValue} webhook`, "error")
    } finally {
      this.testButtonTarget.disabled = false
      this.testButtonTarget.textContent = "Test"
    }
  }

  showStatus(message, type) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.className = `text-xs ${type === "success" ? "text-theme-success" : "text-theme-error"}`
      this.statusTarget.classList.remove("hidden")
      
      // Hide after 5 seconds
      setTimeout(() => {
        this.statusTarget.classList.add("hidden")
      }, 5000)
    }
  }

  isValidWebhookUrl(url) {
    try {
      const urlObj = new URL(url)
      return urlObj.protocol === "https:" && urlObj.hostname.length > 0
    } catch {
      return false
    }
  }

  updateWebhookStatus(configured) {
    // Find and update the webhook status indicator
    const statusElement = document.querySelector(`[data-${this.platformValue}-status]`)
    if (statusElement) {
      if (configured) {
        statusElement.innerHTML = `<span class="text-theme-success">✓ ${this.platformValue} is configured and ready</span>`
      } else {
        statusElement.innerHTML = `Enter a valid ${this.platformValue} webhook URL to enable ${this.platformValue} notifications`
      }
    }
  }
}